export default "__VITE_ASSET__CWO$3Apn__"